import Vue from "vue"

Vue.mixin({
    computed: {

    }
})
